import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();



  const anchorSpace = window.innerHeight * 0.1; // 5vw
  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // ページ内リンク対応
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const targetId = anchor.getAttribute('href');
      const target = document.querySelector(targetId);

      if (!target) return;

      e.preventDefault();

      lenis.scrollTo(target, {
        offset: -anchorSpace,       // 固定ヘッダーあるなら調整
        duration: 1.2,   // スクロール時間
        easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      });
    });
  });



  // メインビジュアル
  if (document.querySelector('.mainimg-slide')) {
    const mvSwiper = new Swiper('.mainimg-slide', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 2000,
      autoplay: {
        delay: 3000,
      },
    });
  }



  const getSpace = () => Math.min(window.innerWidth * 0.05, 35);

  let swiper;
  if (document.querySelector('.index-information-slide-inner')) {
    swiper = new Swiper('.index-information-slide-inner', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 2.5,
      spaceBetween: getSpace(),
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.8,
        },
        1024: {
          slidesPerView: 4.2,
        },
      },
    });
  }



  if (document.querySelector('.about-overview-slide-inner')) {
    const aboutSwiper = new Swiper('.about-overview-slide-inner', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 2.5,
      spaceBetween: getSpace(),
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.8,
        },
        1024: {
          slidesPerView: 4.2,
        },
      },
    });
  }


  window.addEventListener('resize', () => {
    if (swiper) {
      swiper.params.spaceBetween = getSpace();
      swiper.update();
    }
  });






  const navBtn = document.querySelector('.nav-btn');
  const head = document.querySelector('.global-nav');
  const isOpen = navBtn.classList.contains('is-open');

  navBtn.addEventListener('click', () => {
    const isPc = window.innerWidth >= BREAKPOINT;
    const isOpen = navBtn.classList.contains('is-open');
    const isTop = window.scrollY <= 5; // Lenis対策

    // 「閉じる」クリックかつトップかつPC
    if (isPc && isOpen && isTop) {
      navBtn.classList.remove('is-open', 'is-show');
      head.classList.remove('is-open');
      return;
    }
    navBtn.classList.toggle('is-open');
    head.classList.toggle('is-open');

  });

  if (!navBtn) return;

  const BREAKPOINT = 1024;

  const checkNavBtn = () => {
    const isPc = window.innerWidth >= BREAKPOINT;
    const isOpen = navBtn.classList.contains('is-open');
    const scrollY = window.scrollY;
    const showPoint = window.innerHeight * 0.7;

    if (!isPc) {
      // SP：常に表示
      navBtn.classList.add('is-show');
      return;
    }

    // PC
    if (isOpen || scrollY >= showPoint) {
      navBtn.classList.add('is-show');
    } else {
      navBtn.classList.remove('is-show');
    }
  };


  checkNavBtn();
  window.addEventListener('scroll', checkNavBtn);
  window.addEventListener('resize', checkNavBtn);




    // h1要素のフェードインアニメーション
  const h1Elements = document.querySelectorAll('h1');

  if (h1Elements.length > 0) {
    // h1要素の初期状態を設定
    gsap.set(h1Elements, {
      opacity: 0,
      y: 30,
      visibility: 'hidden'
    });

    // ページローディング完了後にアニメーション実行
    setTimeout(() => {
      gsap.to(h1Elements, {
        opacity: 1,
        y: 0,
        visibility: 'visible',
        duration: 0.5,
        ease: 'power2.out',
        stagger: 0.1
      });
    }, 500); // ローディングアニメーションの完了を待つ
  }


  // h1要素以外のフェードインアニメーション
  let els = document.querySelectorAll('.js-fadeIn');

  function checkFadeIn() {
    let windowHeight = window.innerHeight;

    els.forEach(function(el) {
      if (el.classList.contains('is-scrollIn')) return;

      let rect = el.getBoundingClientRect();

      if (rect.top < windowHeight - 250) {
        el.classList.add('is-scrollIn');
      }
    });
  }

  window.addEventListener('scroll', checkFadeIn);
  window.addEventListener('load', checkFadeIn);





  // h1要素以外のフェードインアニメーション 子要素をディレイ付きで表示
  let parents = document.querySelectorAll('.js-fade-parent');

  function checkParentFade() {
    let windowHeight = window.innerHeight;

    parents.forEach(function(parent) {
      if (parent.classList.contains('is-shown')) return;

      let rect = parent.getBoundingClientRect();

      // 親が画面内に入ったら
      if (rect.top < windowHeight - 250) {
        parent.classList.add('is-shown');

        let children = parent.querySelectorAll('.js-fade-child');

        children.forEach(function(child, index) {
          setTimeout(function() {
            child.classList.add('is-scrollIn');
          }, index * 250);
        });
      }
    });
  }

  window.addEventListener('scroll', checkParentFade);
  window.addEventListener('load', checkParentFade);



  // 全ての .js-scroll 要素を取得
  const scrollHints = document.querySelectorAll('.js-scroll');

  // 取得した要素に対して一つずつ処理を行う
  scrollHints.forEach((el) => {
    new ScrollHint(el, {
      i18n: {
        scrollable: "横スクロール",
      },
    });
  });

});
